export default "__VITE_ASSET__Du6ILhX6__"